import { fetchWithErrorThrowing } from 'ck-utils';

export const deleteNews = async (id: string) =>
  fetchWithErrorThrowing(`/news-posts/${id}`, {
    method: 'DELETE',
  });
